// Mondaine Style — mock data (used by the frontend-only MVP)

export const BRAND = {
  name: 'Mondaine Style',
  tagline: 'Dress Like The Man You Want To Become.',
  location: 'HSR, Bengaluru',
  phone: '+91 96110 89898',
  phoneRaw: '919611089898',
  email: 'mondainestyle@gmail.com',
  instagram: 'mondainestyle',
  logo: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/2gj61r48_mondaine_style_logo_transparent.png',
};

// Top-level navigation. `children` renders as a dropdown.
export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  {
    label: 'Services',
    to: '/personal-styling',
    children: [
      { label: 'Personal Styling', to: '/personal-styling' },
      { label: 'Wardrobe Audit', to: '/personal-styling#wardrobe-edit' },
      { label: 'Personal Shopping', to: '/personal-styling#personal-shopping' },
      { label: 'International Personal Shopping', to: '/shop-the-world' },
      { label: 'Corporate Workshops', to: '/corporate-training' },
      { label: 'Retail Staff Training', to: '/corporate-training#retail' },
    ],
  },
  { label: 'Client Transformations', to: '/client-transformations' },
  { label: 'Style Journal', to: '/style-journal' },
  { label: 'Contact', to: '/contact' },
];

export const WHY_MONDAINE = [
  { n: '01', t: 'NIFT Bangalore Alumnus', b: 'Trained at India\u2019s premier design institute \u2014 the technical foundation behind every wardrobe call.' },
  { n: '02', t: '14+ Years In Menswear, Styling & Image Strategy', b: 'A career inside fashion, retail, personal styling and image consulting \u2014 not a stylist who arrived from social media.' },
  { n: '03', t: 'Guest Faculty & Speaker At NIFT, NIT Trichy', b: 'Style and image workshops conducted for educational institutions \u2014 academia takes the practice seriously.' },
  { n: '04', t: 'Workshops With WeWork, Commune Coworks, 91Springboard', b: 'Image strategy and personal branding sessions delivered across professional communities and coworking ecosystems.' },
  { n: '05', t: 'Private 1:1 Styling Practice', b: 'Founder-led engagements with a deliberately limited monthly intake \u2014 every wardrobe is personal, never templated.' },
];

export const CREDENTIALS = [
  'NIFT Bangalore Alumnus',
  '14+ Years in Menswear, Styling & Image Strategy',
  'Founder, Mondaine Style',
  'Guest Faculty & Speaker Engagements with NIFT Bangalore',
  'Conducted Style & Image Workshops at NIT Trichy',
  'Workshop Facilitator at WeWork',
  'Conducted Professional Styling Sessions at Commune Coworks',
  'Style & Image Workshops at 91Springboard',
  'Specialist in Men\u2019s Personal Styling, Wardrobe Transformation & Image Consulting',
];

export const WORKSHOP_INSTITUTIONS = [
  { name: 'NIFT Bangalore', kind: 'Educational' },
  { name: 'NIT Trichy', kind: 'Educational' },
  { name: 'WeWork', kind: 'Professional' },
  { name: 'Commune Coworks', kind: 'Professional' },
  { name: '91Springboard', kind: 'Professional' },
];

export const WORKSHOP_TOPICS = [
  'Personal Branding',
  'Executive Presence',
  'Professional Dressing',
  'First Impression Psychology',
  'Personal Style Strategy',
  'Grooming & Image Consulting',
];

// Real workshop photography — sessions delivered across India.
export const WORKSHOP_GALLERY = [
  {
    id: 'nit-trichy-group',
    venue: 'NIT Trichy',
    kind: 'Educational',
    date: '8 October 2023',
    title: 'Style & Image Workshop \u2014 NIT Trichy',
    caption: 'Personal style and image strategy session with engineering students at NIT Trichy, Tamil Nadu.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/ph5ifz8w_ChatGPT%20Image%20Jun%208%2C%202026%2C%2012_58_21%20PM.png',
    aspect: 'wide',
  },
  {
    id: 'nit-trichy-session',
    venue: 'NIT Trichy',
    kind: 'Educational',
    date: '8 October 2023',
    title: 'Session in progress \u2014 NIT Trichy',
    caption: 'Anitya addressing students on the impact of personal image on confidence and credibility.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/2keoj4w1_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_00_34%20PM.png',
    aspect: 'tall',
  },
  {
    id: 'nit-trichy-bodyshape',
    venue: 'NIT Trichy',
    kind: 'Educational',
    title: 'Body Shape & Style Strategy',
    caption: 'A live segment on body shape, proportion and the rules of dressing that follow.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/892wxzzw_ChatGPT%20Image%20Jun%208%2C%202026%2C%2012_48_07%20PM.png',
    aspect: 'tall',
  },
  {
    id: 'nift-bengaluru',
    venue: 'NIFT Bengaluru',
    kind: 'Educational',
    title: 'Guest Faculty Session \u2014 NIFT Bengaluru',
    caption: 'Difference Between Fashion & Style \u2014 a guest faculty session at the National Institute of Fashion Technology, Bengaluru.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/zrocu4bo_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2002_43_30%20PM.png',
    aspect: 'square',
  },
  {
    id: 'coworking-group-selfie',
    venue: 'Coworking Workshop',
    kind: 'Professional',
    title: 'Workshop session with professionals',
    caption: 'A live style and image session with a coworking community in Bengaluru.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/wmuvb0cr_e0c27821-b847-443c-8ecf-2c79305b69c1.JPG',
    aspect: 'square',
  },
  {
    id: 'coworking-lounge-group',
    venue: 'Coworking Workshop',
    kind: 'Professional',
    title: 'Post-session at the coworking lounge',
    caption: 'Group photo with workshop participants after a personal branding session at a Bengaluru coworking space.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/97bmqvrb_c4d758f3-708d-4713-aa28-5e8a8bb080bb.JPG',
    aspect: 'square',
  },
  {
    id: 'coworking-style-investment',
    venue: 'Coworking Workshop',
    kind: 'Professional',
    title: '\u201CStylish People Are Not Afraid To Invest\u201D',
    caption: 'A live workshop session on why stylish men invest in quality \u2014 delivered across coworking and professional communities.',
    src: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/tyx17cxt_ba37a85e-60e1-439d-803e-eb223ff9d205.JPG',
    aspect: 'square',
  },
];

// Social proof — final numbers per founder
export const STATS = [
  { value: '14+', label: 'Years of Industry Experience' },
  { value: '100+', label: 'Clients Styled' },
  { value: '500+', label: 'Workshop Participants' },
  { value: 'India & International', label: 'Clients Served' },
];

export const HERO_IMAGES = [
  'https://images.pexels.com/photos/8832159/pexels-photo-8832159.jpeg',
  'https://images.pexels.com/photos/15536113/pexels-photo-15536113.jpeg',
  'https://images.pexels.com/photos/6765639/pexels-photo-6765639.jpeg',
];

export const PROBLEMS = [
  { n: '01', text: 'You waste money on clothes that don\u2019t work together' },
  { n: '02', text: 'You follow trends that don\u2019t actually suit you' },
  { n: '03', text: 'Your wardrobe is full but you have nothing to wear' },
  { n: '04', text: 'Your appearance doesn\u2019t match your career and ambition' },
  { n: '05', text: 'You feel invisible in rooms where you should command attention' },
];

// Premium tagline used on the Problem section
export const PROBLEM_HEADLINE = {
  eyebrow: 'Why Most Men Struggle With Style',
  title: 'You don\u2019t need more clothes. You need a wardrobe <em>strategy.</em>',
  body: 'Most men waste money buying pieces that don\u2019t work together, follow trends that don\u2019t suit them, and end up with wardrobes full of clothes but nothing to wear. Mondaine Style helps you build a wardrobe that works for your lifestyle, body type, career goals and personality.',
};

// New: International Personal Shopping pricing
export const INTL_SHOPPING_PRICING = [
  { id: 'singapore', city: 'Singapore', price: '\u20B935,000', sub: 'Onwards', body: 'Premium workwear, smart casuals, luxury basics, grooming and accessories.' },
  { id: 'dubai', city: 'Dubai', price: '\u20B945,000', sub: 'Onwards', body: 'Luxury fashion, occasionwear, watches, shoes and statement wardrobes.', feature: true },
  { id: 'china', city: 'China', price: '\u20B950,000', sub: 'Onwards', body: 'Custom sourcing, fabrics, bulk wardrobe building and unique menswear finds.' },
  { id: 'virtual', city: 'Virtual Consultation', price: '\u20B915,000', sub: 'Onwards', body: 'Remote international shopping guidance \u2014 brand lists, links, sizing and timing.' },
];

// Client Transformations — Before/After composite images only.
// Anonymised: no names, professions, quotes or personal descriptions are associated
// with any individual client. Studio process is described separately in
// TRANSFORMATION_PROCESS below.
export const TRANSFORMATIONS = [
  { id: 'transformation-01', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/are8vssu_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_28_51%20PM.png' },
  { id: 'transformation-02', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/qdv8qpm8_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_30_05%20PM.png' },
  { id: 'transformation-03', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/ppkd0vj6_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_32_15%20PM.png' },
  { id: 'transformation-04', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/re505kiz_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_35_29%20PM.png' },
  { id: 'transformation-05', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/s7lngsme_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_37_22%20PM.png' },
  { id: 'transformation-06', composite: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/bzyyhrp1_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2003_39_33%20PM.png' },
];

// Generic studio methodology — not associated with any specific client or face.
export const TRANSFORMATION_PROCESS = {
  eyebrow: 'The Studio Process',
  title: 'Every transformation begins with <em>a conversation.</em>',
  body: 'No two engagements are identical. The studio works with private clients across milestones — leadership moments, weddings, founder journeys, grooming resets, complete image rebuilds. Faces and stories are kept confidential; the work is shared in outcomes, not identities.',
  steps: [
    {
      label: 'Challenge',
      body: 'A private session to understand the client\u2019s current wardrobe, body, palette, profession and ambition \u2014 and what their image is quietly costing them.',
    },
    {
      label: 'Process',
      body: 'A bespoke combination of wardrobe edit, image strategy, personal shopping and grooming guidance \u2014 delivered over weeks, founder-led from start to finish.',
    },
    {
      label: 'Result',
      body: 'A wardrobe and presence that finally matches the version of themselves the client has been working toward \u2014 considered, intentional and unmistakably their own.',
    },
  ],
};

export const METHOD = [
  { n: '01', title: 'Discover', sub: 'Style DNA Assessment', body: 'We map your body shape, color profile, lifestyle and ambitions to define a signature.' },
  { n: '02', title: 'Edit', sub: 'Wardrobe Audit', body: 'We rebuild the existing — keep, alter, retire. A precise inventory of what already serves you.' },
  { n: '03', title: 'Build', sub: 'Personal Shopping', body: 'Curated brand journeys and intentional purchases that close the gaps with purpose.' },
  { n: '04', title: 'Transform', sub: 'Image & Lifestyle Upgrade', body: 'Outfits for every room — boardrooms, ceremonies, off-duty. Calibrated for confidence.' },
];

export const SERVICES = [
  {
    id: 'clarity',
    title: 'Style Clarity Consultation',
    audience: 'Professionals unsure where to begin',
    price: '\u20B97,500',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/r989wwnh_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_05_37%20PM.jpeg',
    description: 'A founder-led 1:1 conversation that defines your style signature — decoding body, color, lifestyle and ambition into a clear direction.',
    deliverables: [
      'Body shape analysis',
      'Color direction',
      'Style personality discovery',
      'Grooming recommendations',
      'Brand recommendations',
    ],
    cta: 'Book Consultation',
  },
  {
    id: 'wardrobe-edit',
    title: 'Wardrobe Edit & Style Reset',
    audience: 'Closets that need an intentional reset',
    price: '\u20B915,000',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/6iyh99wq_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_16_02%20PM.png',
    description: 'An in-home audit that retires what no longer serves you and reorganises what does — leaving you with outfits, not options.',
    deliverables: [
      'Wardrobe audit',
      'Outfit combinations',
      'Keep / Alter / Remove strategy',
      'Missing essentials list',
      'Shopping roadmap',
    ],
    cta: 'Reset My Wardrobe',
  },
  {
    id: 'personal-shopping',
    title: 'Personal Shopping Experience',
    audience: 'Curated, time-efficient shopping',
    price: '\u20B925,000',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/7di7e03w_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_14_15%20PM.png',
    description: 'A stylist-led shopping day across the right brands and stores — every piece chosen to extend your wardrobe with intent.',
    deliverables: [
      'Pre-shopping consultation',
      'Brand planning',
      'Curated shopping journey',
      'Outfit building',
      'Smart budget allocation',
    ],
    cta: 'Shop With A Stylist',
  },
  {
    id: 'executive',
    title: 'Executive Image Consulting',
    audience: 'Founders, CXOs and senior leaders',
    price: '\u20B935,000',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/vrh37ult_ChatGPT%20Image%20Jun%208%2C%202026%2C%2010_41_40%20PM.png',
    description: 'A leadership wardrobe strategy designed for the room — boardrooms, panels, keynotes and client meetings.',
    deliverables: [
      'Leadership dressing strategy',
      'Executive wardrobe planning',
      'Personal brand image',
      'Meeting & presentation dressing',
      'Professional presence upgrade',
    ],
    cta: 'Elevate My Executive Image',
  },
  {
    id: 'wedding',
    title: 'Groom & Wedding Styling',
    audience: 'Grooms preparing for the year ahead',
    price: 'Starting \u20B945,000',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/ktjmuxsp_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_41_52%20PM.jpeg',
    description: 'A complete wedding wardrobe — sangeet, cocktail, mehendi, ceremony, reception — coordinated, fitted and considered.',
    deliverables: [
      'Wedding wardrobe planning',
      'Outfit coordination',
      'Personal shopping',
      'Accessories styling',
      'Family styling options',
    ],
    cta: 'Style My Wedding',
  },
  {
    id: 'transformation',
    title: 'Complete Style Transformation',
    audience: 'The Signature Experience',
    price: '\u20B965,000',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/0jopdsbs_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_27_47%20PM.png',
    description: 'Our flagship private engagement — consultation, edit, shopping, image strategy and 30-day stylist support, end to end.',
    deliverables: [
      'Style consultation',
      'Wardrobe audit',
      'Personal shopping',
      'Digital style report',
      '30-day WhatsApp support',
    ],
    cta: 'Transform My Style',
    feature: true,
  },
];

// Personal Styling — Five core engagements (mapped to existing SERVICES by id)
export const PERSONAL_STYLING_CATEGORIES = [
  { id: 'clarity', label: 'Personal Styling' },
  { id: 'personal-shopping', label: 'Personal Shopping' },
  { id: 'wardrobe-edit', label: 'Wardrobe Edit' },
  { id: 'executive', label: 'Image Consulting' },
  { id: 'wedding', label: 'Wedding & Occasion Styling' },
];

// Corporate Training — Six B2B pillars
export const CORPORATE_TRAINING_PILLARS = [
  {
    id: 'executive-presence',
    title: 'Executive Presence & Personal Branding',
    audience: 'Founders, CXOs, senior managers, consultants',
    body: 'A leadership presence program built around how you walk in, what you wear and how the room reads you before you speak.',
  },
  {
    id: 'professional-dressing',
    title: 'Professional Dressing & Grooming',
    audience: 'Mid- to senior-career professionals',
    body: 'A focused workshop on dressing for the room, daily grooming standards and the quiet details of business presence.',
  },
  {
    id: 'retail-staff',
    title: 'Retail Staff Training',
    audience: 'Premium menswear, luxury & wedding retail teams',
    body: 'A floor-ready program turning store staff into styling-led sellers — grooming, brand-appropriate dress and conversion.',
  },
  {
    id: 'luxury-clienteling',
    title: 'Luxury Sales & Clienteling',
    audience: 'Luxury retail managers & senior advisors',
    body: 'A clienteling masterclass — building VIP relationships, wardrobe-led selling, and managing high-net-worth clients.',
  },
  {
    id: 'leadership-workshop',
    title: 'Leadership Presence Workshop',
    audience: 'Leadership offsites & boards',
    body: 'An intensive day on authority dressing, boardroom presence, conference posture and personal-brand consistency.',
  },
  {
    id: 'campus-to-corporate',
    title: 'Campus To Corporate Programmes',
    audience: 'MBA, engineering and university institutions',
    body: 'A graduating-class program preparing students for the first 100 days of corporate life \u2014 dressing, presence and digital footprint.',
  },
];

// Corporate Training — Five high-value detailed modules with topic lists
export const CORPORATE_MODULES = [
  {
    id: 'executive-presence',
    title: 'Executive Presence For Leaders',
    audience: 'Founders, CXOs, senior managers, consultants',
    topics: [
      'Authority Dressing',
      'Boardroom Presence',
      'Personal Brand Positioning',
      'Executive Wardrobe Strategy',
    ],
  },
  {
    id: 'retail-staff',
    title: 'Retail Staff Training',
    audience: 'Premium menswear, luxury, wedding retail teams',
    topics: [
      'Selling Through Styling',
      'Customer Psychology',
      'Visual Presentation',
      'Premium Customer Handling',
      'Upselling & Cross-Selling',
    ],
  },
  {
    id: 'luxury-clienteling',
    title: 'Luxury Clienteling Workshop',
    audience: 'Luxury retail teams & senior client advisors',
    topics: [
      'Building VIP Customer Relationships',
      'Wardrobe-Led Selling',
      'Relationship Selling',
      'High-Net-Worth Client Handling',
    ],
  },
  {
    id: 'campus-to-corporate',
    title: 'Campus To Corporate',
    audience: 'MBA colleges, engineering colleges and universities',
    topics: [
      'First Impressions',
      'Interview Dressing',
      'LinkedIn Presence',
      'Corporate Wardrobe Essentials',
    ],
  },
  {
    id: 'founder-branding',
    title: 'Founder Personal Branding',
    audience: 'Founders building visibility and category authority',
    topics: [
      'Investor Meetings',
      'Media Appearances',
      'Conference Dressing',
      'Personal Brand Consistency',
    ],
  },
];


export const SHOP_WORLD_DESTINATIONS = [
  {
    id: 'singapore',
    city: 'Singapore',
    tag: 'Style Trip',
    price: '\u20B975,000 \u2013 \u20B91,25,000',
    body: 'Premium workwear, smart casuals, luxury basics, grooming and accessories. The modern professional wardrobe, sharpened.',
    image: 'https://images.pexels.com/photos/37793325/pexels-photo-37793325.jpeg',
  },
  {
    id: 'dubai',
    city: 'Dubai',
    tag: 'Luxury Shopping Trip',
    price: '\u20B91,25,000 \u2013 \u20B92,50,000',
    body: 'Luxury fashion, occasionwear, watches, shoes, wedding shopping and statement wardrobes from the worlds finest houses.',
    image: 'https://images.pexels.com/photos/35572910/pexels-photo-35572910.jpeg',
  },
  {
    id: 'china',
    city: 'China',
    tag: 'Sourcing & Style Trip',
    price: '\u20B91,50,000 \u2013 \u20B93,00,000',
    body: 'Custom sourcing, fabrics, bulk wardrobe building and unique menswear finds — manufacturing-linked shopping done right.',
    image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/4keuy9zh_0BABFCCA-189D-4DDC-BD60-9F4B00F9FBFA.PNG',
  },
];

export const SHOP_WORLD_BENEFITS = [
  'Pre-trip style planning',
  'Personal shopping itinerary',
  'Brand and mall curation',
  'Tax-saving and value-shopping guidance',
  'Outfit building',
  'Occasion-based wardrobe planning',
  'Luxury, premium and smart-value options',
  'WhatsApp support before and after the trip',
];

export const RETAIL_MODULES = [
  'Grooming and personal presentation',
  'Brand-appropriate styling',
  'Customer body-type understanding',
  'Styling-based selling',
  'Upselling complete looks',
  'Occasion-based recommendation',
  'Premium client handling',
];

export const RETAIL_IDEAL_FOR = [
  'Store teams',
  'New season launches',
  'Luxury retail',
  'Premium menswear',
  'Wedding and occasionwear stores',
];

export const RETAIL_PRICING = [
  { id: 'starter', name: 'Starter Workshop', price: '\u20B935,000', sub: '2-hour session, up to 10 staff', body: 'A focused introduction to grooming, styling and selling fundamentals for store teams.' },
  { id: 'half', name: 'Half-Day Training', price: '\u20B965,000 \u2013 \u20B990,000', sub: '4 hours, up to 20 staff', body: 'Hands-on modules covering body types, brand styling and upselling complete looks.' },
  { id: 'full', name: 'Full-Day Premium Training', price: '\u20B91,25,000 \u2013 \u20B91,75,000', sub: '6\u20137 hours, roleplay, scripts', body: 'A full immersion — grooming, styling, selling scripts and premium client handling.', feature: true },
  { id: 'retainer', name: 'Monthly Retainer', price: '\u20B975,000 \u2013 \u20B91,50,000/mo', sub: 'For brands with multiple stores', body: 'Ongoing training for seasonal launches and multi-store rollouts.' },
];

export const TESTIMONIALS = [
  {
    name: 'Anuj J.',
    role: 'Private Client',
    quote: 'I am at a life stage and a professional status where I needed to reinvent myself.',
    avatar: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/40h8oby5_ChatGPT%20Image%20May%2025%2C%202026%2C%2005_59_48%20PM.png',
  },
];

export const FAQS = [
  {
    q: 'How does personal shopping work?',
    a: 'Every shopping engagement begins with a private conversation to understand your lifestyle and gaps. We then plan a curated route across the right brands — boutique, luxury and value — and shop together over a half or full day.',
  },
  {
    q: 'How much should I budget for clothing?',
    a: 'Shopping budgets are entirely yours to define. We work as efficiently with a focused ₹50,000 refresh as we do with a multi-lakh occasion wardrobe — discipline matters more than scale.',
  },
  {
    q: 'Can I do this virtually?',
    a: 'Yes. Our Online Styling engagement delivers consultation, audits and curated lookbooks remotely — for clients beyond Bengaluru or those who prefer to start digitally.',
  },
  {
    q: 'Do you style grooms?',
    a: 'Wedding and occasion styling is one of our signature engagements. We coordinate every function — sangeet to reception — and can extend the styling to immediate family.',
  },
  {
    q: 'How long does a transformation take?',
    a: 'The Signature Experience typically unfolds over 4–6 weeks. Standalone consultations or wardrobe edits can be completed in a single appointment.',
  },
  {
    q: 'Do you work with specific brands?',
    a: 'We are entirely independent. Recommendations are made on fit, quality and relevance to your lifestyle — never affiliation.',
  },
];

export const CLIENT_TAGS = [
  'Founders', 'Executives', 'Consultants', 'Entrepreneurs',
  'Grooms', 'Professionals', 'Public Speakers', 'High Performers',
];

export const JOURNAL_POSTS = [
  {
    id: 'ten-piece',
    title: 'The 10-Piece Wardrobe Every Modern Indian Man Needs',
    excerpt: 'A foundational essay on the ten pieces that quietly carry your week — for work, weekend, travel and occasion.',
    image: 'https://images.pexels.com/photos/8832159/pexels-photo-8832159.jpeg',
    category: 'Wardrobe Essentials',
    date: 'July 2025',
    read: '6 min',
  },
  {
    id: 'colour',
    title: 'Colour, Restrained: A Modern Indian Mans Palette',
    excerpt: 'On building a colour system that flatters Indian skin tones without slipping into either beige boredom or carnival brights.',
    image: 'https://images.pexels.com/photos/15536113/pexels-photo-15536113.jpeg',
    category: 'Style Theory',
    date: 'July 2025',
    read: '5 min',
  },
  {
    id: 'travel',
    title: 'The Carry-On Wardrobe: Five Days, One Suitcase',
    excerpt: 'A founders travel formula — capsule pieces that survive boardrooms, dinners and a single light bag.',
    image: 'https://images.pexels.com/photos/4259966/pexels-photo-4259966.jpeg',
    category: 'Travel',
    date: 'June 2025',
    read: '4 min',
  },
  {
    id: 'wedding',
    title: 'A Restrained Grooms Manual',
    excerpt: 'On dressing for your own wedding without disappearing into pageantry — or into the buffet line.',
    image: 'https://images.pexels.com/photos/29204802/pexels-photo-29204802.jpeg',
    category: 'Weddings',
    date: 'June 2025',
    read: '7 min',
  },
  {
    id: 'fit',
    title: 'Fit Is The Whole Conversation',
    excerpt: 'Why an average shirt that fits will out-dress a luxury shirt that does not — and how to know the difference.',
    image: 'https://images.pexels.com/photos/6765639/pexels-photo-6765639.jpeg',
    category: 'Fundamentals',
    date: 'May 2025',
    read: '5 min',
  },
  {
    id: 'fragrance',
    title: 'A Quiet Note On Fragrance',
    excerpt: 'Three principles for choosing fragrance like an adult — and wearing it like one too.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a',
    category: 'Grooming',
    date: 'May 2025',
    read: '3 min',
  },
];

export const FOUNDER = {
  name: 'Anitya Vatsal',
  role: 'Founder | Style Consultant | Menswear Design Expert',
  tagline: 'Style is intentional. Impact is timeless.',
  image: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/ckgmxvoh_ChatGPT%20Image%20Jun%208%2C%202026%2C%2010_48_24%20PM.jpeg',
  portrait: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/3eh0dhrx_C0C4D22E-D15A-42CD-AF57-9F30F24DC5FA.PNG',
  editorial: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/njtdh5df_ChatGPT%20Image%20Jun%207%2C%202026%2C%2001_40_35%20PM%202.PNG',
  seated: 'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/67pqf4pe_ChatGPT%20Image%20Jun%208%2C%202026%2C%2010_48_24%20PM.png',
  bio: [
    'Anitya founded Mondaine Style after a decade inside fashion, retail and menswear design — quietly noticing the same pattern in successful Indian men. Their careers evolved. Their image did not.',
    'Mondaine is his answer. A private, founder-led studio that helps Indian men dress with confidence, clarity and a kind of quiet power — across boardrooms, weddings, travel and life off duty.',
    'Every engagement is personal. Every wardrobe is intentional. And every client is, by design, one of only a handful taken on each month.',
    'Mondaine Style exists for men who understand that personal style is not about fashion — it is about influence, confidence and presence.',
  ],
};

export const FOUNDER_GALLERY = [
  'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/njtdh5df_ChatGPT%20Image%20Jun%207%2C%202026%2C%2001_40_35%20PM%202.PNG',
  'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/3eh0dhrx_C0C4D22E-D15A-42CD-AF57-9F30F24DC5FA.PNG',
  'https://customer-assets.emergentagent.com/job_mondaine-luxury/artifacts/67pqf4pe_ChatGPT%20Image%20Jun%208%2C%202026%2C%2010_48_24%20PM.png',
];
